"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const mobx_react_1 = require("mobx-react");
const permission_actions_1 = require("@App/enum/permission-actions");
const UserActionPopup_1 = require("@Components/Popups/UserActionPopup");
const contexts_1 = require("@App/contexts");
const rightsholderUser_1 = require("@App/api/routes/rightsholder/rightsholderUser");
const navigation_1 = __importDefault(require("@App/navigation"));
const react_router_dom_1 = require("react-router-dom");
const ChangePermissionPopup_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderMaintenanceUserPermissionsProfile/UserPermissionsModal/ChangePermissionPopup"));
const UserPermissionsModal = (props) => {
    const params = (0, react_router_dom_1.useParams)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { preloaderStore, popupStore, userStore, rightsholderUserStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const { actionType, rightsholderUser, onCloseConfirmPopup, editActionsGroups, myUserGroups, setRightsholderUser, setUsersGroup, getUsersForUser, onCancelEdit, } = props;
    const onResentInvite = () => __awaiter(void 0, void 0, void 0, function* () {
        const user = rightsholderUser;
        if (user) {
            preloaderStore.openTransparentPreloader(true);
            const { firstName, lastName, email, groups } = user;
            try {
                const formData = { firstName, lastName, email, groups };
                yield rightsholderUserStore.inviteRightsholderUser(formData);
                popupStore.setAlertData(`Invite was resent`, false);
            }
            catch (error) {
                popupStore.setAlertFromError(error);
            }
            onCloseConfirmPopup();
            preloaderStore.openTransparentPreloader(false);
        }
    });
    const onRemoveUser = () => __awaiter(void 0, void 0, void 0, function* () {
        const currentRightsHolderId = Number(params.rightsholderId);
        const user = rightsholderUser;
        if (user === null || user === void 0 ? void 0 : user.id) {
            preloaderStore.openTransparentPreloader(true);
            const { id, firstName, lastName } = user;
            try {
                yield (0, rightsholderUser_1.deleteRightsholderUser)(currentRightsHolderId, id);
                navigate(navigation_1.default.rightholder.maintenance.userPermissions(currentRightsHolderId));
                popupStore.setAlertData(`User ${firstName + ' ' + lastName} was removed`, false);
            }
            catch (error) {
                popupStore.setAlertFromError(error);
            }
            onCloseConfirmPopup();
            preloaderStore.openTransparentPreloader(false);
        }
    });
    switch (actionType) {
        case permission_actions_1.PermissionActions.changePermissions:
            return (react_1.default.createElement(ChangePermissionPopup_1.default, { rightsholderUser: rightsholderUser, setRightsholderUser: setRightsholderUser, myUserGroups: myUserGroups, editActionsGroups: editActionsGroups, getUsersForUser: getUsersForUser, onCloseConfirmPopup: onCloseConfirmPopup, setUsersGroup: setUsersGroup, onCancelEdit: onCancelEdit }));
        case permission_actions_1.PermissionActions.resentInvite:
            return (react_1.default.createElement(UserActionPopup_1.UserActionPopup, { title: 'Resend Invite?', user: rightsholderUser, onCancel: onCloseConfirmPopup, onConfirm: onResentInvite }));
        case permission_actions_1.PermissionActions.removeUser:
            return (react_1.default.createElement(UserActionPopup_1.UserActionPopup, { title: 'Remove User?', user: rightsholderUser, onCancel: onCloseConfirmPopup, onConfirm: onRemoveUser, disabled: userStore.isInternal }));
        default:
            return react_1.default.createElement(react_1.default.Fragment, null);
    }
};
exports.default = (0, mobx_react_1.observer)(UserPermissionsModal);
